import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum ReportTemplatesViewColumn {
    NAME = "name",
    DESCRIPTION = "description",
    ENTITIES = "entities",
    ACTIONS = "actions",
}

const makeColumnSchema = (id: ReportTemplatesViewColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const ReportTemplatesViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.REPORT_TEMPLATES),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(ReportTemplatesViewColumn.NAME),
            makeColumnSchema(ReportTemplatesViewColumn.DESCRIPTION),
            makeColumnSchema(ReportTemplatesViewColumn.ENTITIES),
            makeColumnSchema(ReportTemplatesViewColumn.ACTIONS),
        ]),
    ),
});

export type ReportTemplatesView = z.infer<typeof ReportTemplatesViewSchema>;
